import { api } from '@smena/ui';

export interface AccountView {
  id: string;
  slug: string;
  name: string;
  kind: 'client' | 'demo';
  playbook: Record<string, unknown>;
  settings: Record<string, boolean | undefined>;
  plan: Record<string, unknown>;
  createdAt: string;
  propertiesCount: number;
}

export interface StaffUserItem {
  id: string;
  email: string;
  name: string;
  role: 'owner' | 'operator';
  active: boolean;
  lastLoginAt: string | null;
  createdAt: string;
}

export async function fetchAccount(): Promise<AccountView> {
  return api('/api/staff/account');
}

export async function patchAccount(data: {
  name?: string;
}): Promise<AccountView> {
  return api('/api/staff/account', { method: 'PATCH', json: data });
}

export async function fetchPlaybook(): Promise<Record<string, unknown>> {
  return api('/api/staff/account/playbook');
}

export async function patchPlaybook(data: Record<string, unknown>): Promise<Record<string, unknown>> {
  return api('/api/staff/account/playbook', { method: 'PATCH', json: data });
}

export async function fetchSettings(): Promise<Record<string, boolean | undefined>> {
  return api('/api/staff/account/settings');
}

export async function patchSettings(data: Record<string, boolean>): Promise<Record<string, boolean | undefined>> {
  return api('/api/staff/account/settings', { method: 'PATCH', json: data });
}

export async function fetchUsers(): Promise<StaffUserItem[]> {
  const r = await api<{ items: StaffUserItem[] }>('/api/staff/account/users');
  return r.items;
}

export async function createUser(data: { email: string; password: string; name: string; role?: 'owner' | 'operator' }): Promise<{ id: string; email: string }> {
  return api('/api/staff/account/users', { method: 'POST', json: data });
}

export interface AuditEntry {
  ts: string;
  actor: string;
  action: string;
  payload: Record<string, unknown>;
}

export async function fetchAudit(): Promise<AuditEntry[]> {
  const r = await api<{ entries: AuditEntry[] }>('/api/staff/account/audit?limit=100');
  return r.entries;
}
